import React from 'react';
import Tooltip, { Placement } from 'react-floater';

import { Icon, ICONS } from 'core/components/Icon';
import * as vr from 'core/styles/variables';

import * as S from './Tooltip.style';

interface IProps {
	icon?: ICONS;
	iconSize?: number;
	content: string | React.ReactNode;
	// Content can be JSX, pass aria-describedby value explicitly
	ariaDescription?: string;
	// Optional config for react floater styles. Reference -> shorturl.at/eEFO7
	// If none passed falls back to default config.
	tooltipStyle?: object;
	// Control the placement of floater tooltip relative to the invoking element
	placement?: Placement;
}

interface IState {
	isOpen: boolean;
}

export default class TooltipModule extends React.PureComponent<IProps, IState> {
	tooltipButton = React.createRef();

	state = {
		isOpen: false,
	};

	private _tooltipToggleState = (state?: boolean) => {
		this.setState((prev: IState) => ({
			isOpen: typeof state === 'boolean' ? state : !prev.isOpen,
		}));
	};

	render() {
		const {
			icon = ICONS.INFO,
			content: tooltipContent,
			iconSize,
			ariaDescription,
			tooltipStyle: floaterStyle,
			placement,
		} = this.props;
		const { isOpen: open } = this.state;
		const content = <S.TooltipContent>{tooltipContent}</S.TooltipContent>;
		const tooltipStyle = floaterStyle
			? floaterStyle
			: {
					floater: {
						filter: 'none',
					},
					container: {
						// TODO should we infer this from theme?
						backgroundColor: '#222222',
						borderRadius: 2,
						color: `${vr.brandWhite}`,
						minHeight: 'none',
						minWidth: 'none',
						padding: 10,
						textAlign: 'center',
					},
					arrow: {
						// TODO should we infer this from theme?
						color: '#222222',
						position: 'absolute',
						length: 8,
						spread: 12,
					},
			  };

		return (
			<Tooltip
				styles={tooltipStyle}
				offset={0}
				{...{ content, open, placement }}
			>
				<S.Tooltip
					type="button"
					role="tooltip"
					aria-expanded={open}
					aria-describedby={ariaDescription}
					onClick={e => {
						const tooltipButton = e.target as HTMLButtonElement;

						// Not all browsers will apply focus to the button on click,
						// so we can do so programmatically to ensure expected 'onBlur' behaviour
						// Ref: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
						tooltipButton.focus();

						this._tooltipToggleState();
					}}
					onBlur={() => {
						this._tooltipToggleState(false);
					}}
				>
					{/* Removing pointer events so clicking on the SVG itself
					doesn't interfere with the onClick event's 'e.target' selector */}
					<Icon name={icon} size={iconSize} style={{ pointerEvents: 'none' }} />
				</S.Tooltip>
			</Tooltip>
		);
	}
}
